import { useEffect, useState } from 'react';
var useMedia = function (query) {
    var mediaQuery = window.matchMedia(query);
    var _a = useState(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
    var handler = function () {
        setMatches(mediaQuery.matches);
        console.log('mobile: ', mediaQuery.matches);
    };
    useEffect(function () {
        mediaQuery.addEventListener('change', handler);
        return function () { return mediaQuery.removeEventListener('change', handler); };
    }, []);
    return matches;
};
export default useMedia;
